var Constructor = require('js/vendor/constructor');
var Request = require('js/lib/request');
var _ = require('underscore');
var Promise = require('js/vendor/promise');
var config = require('js/config');


// Map from CRUD to HTTP for our default `Backbone.sync` implementation.
var methodMap = {
  create: 'POST',
  update: 'PUT',
  patch: 'PATCH',
  delete: 'DELETE',
  read: 'GET',
};

/**
 * Handle completing a promise
 * TODO: Tidy up the promise logic here... handleResponse and parseData are v. similar
 */
var handleResponse = function(promise, data, breakOnError) {
  var success = data.status && data.status.success && (!breakOnError || !data.status.errors.length);

  // CHAOS-271 Passing status through payload to check responseCode of context for focus groups
  if (data.payload && typeof data.payload === 'object') {
    data.payload._status = data.status;
  }

  return success ? promise.fulfil(data.payload) : promise.break(data.status);
};

/**
 * Parse an api data object for a promise
 */
var parseData = function(data, breakOnError) {
  var success = data.status && data.status.success && (!breakOnError || !data.status.errors.length);

  // CHAOS-271 Passing status through payload to check responseCode of context for focus groups
  if (data.payload && typeof data.payload === 'object') {
    data.payload._status = data.status;
  }

  return success ? data.payload : Promise.broken(data.status);
};

/**
 * Create a new api constructor
 */
var Api = Constructor.extend();

/**
 * Make a new request taking into account our api data formats. (takes same options as Request)
 * @static
 * @param  {String|Object} url The url to send a request to or options object
 * @param  {Object} options Request options
 * @return {Promise}        A promise to api data
 */
Api.request = Api.get = function(url, options) {
  var bootKey = null; // Store the key used for bootstrapping


  // Construct options
  var constructedOptions = Request.constructOptions(url, options);

  var defaultOptions = {
    dataType: 'json',
    type: 'GET',
  };

  if (config.build.apiPath !== '') {
    // For CORS request between Ecliptic and Wepback server
    defaultOptions.xhrFields = {
      withCredentials: true,
    };
  }

  // Merge with defaults
  constructedOptions = _.extend(defaultOptions, constructedOptions);

  // Have we bootstrapped the data we are after?
  var bootXhr = _.find(bootData, function(v, key) {
    bootKey = key;
    return constructedOptions.url.indexOf(key) > -1;
  });

  // If we have bootstrapped some data we just want to return that
  if (bootXhr) {
    // We only care about bootstrapped data this once!
    delete bootData[bootKey];

    var bootPromise = new Promise();

    // Is the request already completed?
    if (bootXhr.readyState === 4) {
      var data = {};

      try {
        data = JSON.parse(bootXhr.responseText);
      } catch (error) {
      }

      handleResponse(bootPromise, data, constructedOptions.breakOnError);
      // Otherwise let s wait
    } else {
      bootXhr.onreadystatechange = function() {
        if (bootXhr.readyState === 4) {
          var data = {};

          try {
            data = JSON.parse(bootXhr.responseText);
          } catch (error) {
          }

          handleResponse(bootPromise, data, constructedOptions.breakOnError);
        }
      };
    }

    return bootPromise;
  }

  // Force json requests
  if (constructedOptions.data && constructedOptions.type !== 'GET' && !constructedOptions.contentType) {
    constructedOptions.contentType = 'application/json';
    constructedOptions.data = JSON.stringify(constructedOptions.data);
  }

  // Don t process data on a non-GET request.
  if (constructedOptions.type !== 'GET') {
    constructedOptions.processData = false;
  }

  return (new Request(constructedOptions)).then(function(data) {
    return parseData(data, constructedOptions.breakOnError);
  });
};

/**
 * Run a Api request but forced to method PUT
 * @return {[Promise} Api data promise
 */
Api.put = function(url, options) {
  // Construct options
  var constructedOptions = Request.constructOptions(url, options);
  constructedOptions.type = 'PUT';

  return Api.request(constructedOptions);
};

/**
 * Run a Api request but forced to method POST
 * @return {[Promise} Api data promise
 */
Api.post = function(url, options) {
  // Construct options
  var constructedOptions = Request.constructOptions(url, options);
  constructedOptions.type = 'POST';

  return Api.request(constructedOptions);
};

/**
 * Run a Api request but forced to method DELETE
 * @return {[Promise} Api data promise
 */
Api.delete = function(url, options) {
  // Construct options
  var constructedOptions = Request.constructOptions(url, options);
  constructedOptions.type = 'DELETE';

  return Api.request(constructedOptions);
};

/**
 * Helper method for Backbone.Sync
 * @static
 */
Api.sync = function(method, model, options) {
  // Default options, unless specified.
  if (!options) {
    options = {};
  }

  // Default JSON-request options.
  var params = {type: methodMap[method]};

  // // Ensure that we have a URL.
  params.url = !options.url ? _.result(model, 'url') : options.url;
  if (!params.url) {
    throw new Error('Expected url property!');
  }

  // Ensure that we have the appropriate request data.
  if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
    params.data = options.attrs || model.toJSON(options);
  } else if (model) { // Take into account a description
    params.data = _.extend({}, model.description, options.data);
  }

  // Set a syncing flag on the model
  model.syncing = true;
  model.startSync();

  // Make the request, allowing the user to override any Ajax options.
  var request = Api.request(_.extend(params, options));

  // Let everyone know this model is syncing data
  model.trigger('syncing');

  // Support old school callbacks (backbone uses them)
  var success = options.success;

  // When promise is translated manage any old school callbacks
  request.then(function(data) {
    model.syncing = false; // Reset syncing flag
    model.endSync();

    if (success) {
      success(data);
    }
  }, function(error) {
    model.syncing = false; // Reset syncing flag
    model.endSync();

    if (options.error) {
      options.error(error);
    }
  });

  // Trigger en event on the model (or collection)
  model.trigger('request', model, request, options);

  return request;
};

module.exports = Api;



// WEBPACK FOOTER //
// ./app/assets/js/api.js